import axios from '../axios';
// entities
import { User } from 'entities/user';

export default {
  get: (id: number): Promise<User> => axios.get(`/users/${id}`),
};
